<template>
  <div class="contacts-terminals">
    <component
      :is="titleTag"
      v-if="hasTitle"
      class="vz-text-align-left"
    >
      {{ title }}
    </component>

    <contacts-terminals-slider
      v-if="!isShort"
      v-model="selectedTerminalGuid"
      :location-guid="locationGuid"
      @change="onTerminalSelect"
    />

    <div class="contacts-terminals-wrapper">
      <div>
        <contacts-terminals-slider
          v-if="isShort"
          v-model="selectedTerminalGuid"
          :location-guid="locationGuid"
          @change="onTerminalSelect"
        />

        <contacts-terminals-card
          with-map-link
          :terminal-guid="selectedTerminalGuid"
        />
      </div>

      <slot/>
    </div>
  </div>
</template>

<script setup lang="ts">
import {storeToRefs} from 'pinia'
import {useCityStore} from '~/stores/city'
import {Terminal} from '~~/types/types'
import {useTerminalStore} from '~/stores/terminal'
import ContactsTerminalsCard from '~/components/public/contacts/contacts-terminals-card.vue'
import ContactsTerminalsSlider from '~/components/public/contacts/contacts-terminals-slider.vue'
import $breakpoints from '~/composables/breakpoints'

const props = defineProps({
  locationGuid: {
    type: String,
    default: ''
  },
  hasTitle: {
    type: Boolean,
    default: false
  },
  titleH3: {
    type: Boolean,
    default: false
  },
  titleWithoutLocation: {
    type: Boolean,
    default: false
  }
})

const {rclCityList} = storeToRefs(useCityStore())
const {terminalList} = storeToRefs(useTerminalStore())
const route = useRoute()
const queryTerminalAddress = route.query.terminal as string

const selectedTerminalGuid = ref(queryTerminalAddress
  ? terminalList.value.find(t => t.address === queryTerminalAddress)?.guid || ''
  : terminalList.value.find(t => t.location_guid === props.locationGuid)?.guid || ''
)

const location = computed(() => {
  return rclCityList.value.find(l => l.guid === props.locationGuid)
})

const title = computed(() => {
  const terminalsCount = terminalList.value.filter(t => t.location.guid === props.locationGuid)?.length || 0
  return props.hasTitle && location.value
    ? `Филиал${terminalsCount > 1 ? 'ы' : ''} ТК "Возовоз"${props.titleWithoutLocation ? '' : (' в г. ' + location.value.name)}: адрес${terminalsCount > 1 ? 'а' : ''}`
    : '' 
})

const titleTag = computed(() => {
  return props.titleH3 ? 'h3' : 'h2'
})

const isShort = computed((): boolean => {
  return $breakpoints.width <= 1087
})

function onTerminalSelect(terminal: Terminal): void {
  selectedTerminalGuid.value = terminal?.guid
}

function initTerminal() {
  selectedTerminalGuid.value = queryTerminalAddress
    ? terminalList.value.find(t => t.address.trim() === queryTerminalAddress)?.guid || ''
    : terminalList.value.find(t => t.location_guid === props.locationGuid)?.guid || ''
}

watch(() => terminalList.value.length, () => {
  if (!selectedTerminalGuid.value) {
    initTerminal()
  }
}, {immediate: true})

watch(() => props.locationGuid, initTerminal)
</script>
